let isLoggingOut = false;
let sessionModalHandler = null;

export const registerSessionModal = (fn) => {
  sessionModalHandler = fn;
};

export const apiFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  if (res.status === 401) {
    if (!isLoggingOut) {
      isLoggingOut = true;

      sessionModalHandler?.(); // 🔥 buka modal login
    }

    return;
  }

  return res;
};